import { Box } from 'grommet';
import { h } from 'preact';

import SocialLoginButton from './SocialLoginButton';

const SocialLoginBar = () => (
  <Box direction="row" gap="8px" align="center" justify="center">
    <SocialLoginButton variant="google" />
    <SocialLoginButton variant="apple" />
    <SocialLoginButton variant="facebook" />
  </Box>
);

export default SocialLoginBar;
